export class RestoreAwsEc2InstanceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AwsEc2InstanceRestoreDestination",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "RestoreInstanceImageInput",
            "format": ""
        },
        {
            "name": "templateId",
            "baseName": "templateId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAwsEc2InstanceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
